import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Img from '../atoms/Img';
import ItemLine from './ItemLine';
import { display } from '../../data/display';
import { toLocationStr } from '../../lib/utils';
import styles from '../../styles/components/organisms/ItemHeader.module.scss';

interface ItemHeaderDisplayProps {
  data: any;
  type: string;
}

/*
 * Intro / Header Data
 */

const ItemHeaderDisplay = (props: ItemHeaderDisplayProps) => {
  const { data, type } = props;
  const { logo, address } = data;
  const displayObj = display[type].platinum.intro;
  const propertyKeys = Object.keys(displayObj);
  const properties = {} as any;
  propertyKeys.forEach((key: string) => {
    const id = key;
    const defaults = displayObj[id];
    const value = data[id] || (defaults ? defaults.value : '');
    properties[id] = value;
  });
  const { rating, rateCnt, name, plan, memberships } = properties as any;
  const promoted = type === 'venue' && ['PLATINUM'].indexOf(plan) > -1;
  const locationLine = toLocationStr(address);

  return (
    <>
      <Row className={styles.itemHeader}>
        <Col xs={8}>
          {!!logo && (
            <div className={styles.logo}>
              <Img src={logo.url} contain />
            </div>
          )}
          <div className={styles.title}>
            <ItemLine
              type={type}
              promoted={promoted}
              rating={rating || '0'}
              rateCnt={rateCnt || '0'}
            />
            <h1>{name}</h1>
            <p>{locationLine}</p>
            {!!memberships.length && <ItemLine memberships={memberships} />}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ItemHeaderDisplay;
